import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { PersonPlusFill } from 'react-bootstrap-icons'
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { Dropdown } from 'rsuite';
import context from '../context/shared';
import { centerClient } from '../../../shared/clients';
import type { Account } from '../../../shared/generated';

interface IAddLoginFormProps {
    clientId: string;
    showTitle: boolean;
    variant?: 'button' | 'dropdownItem';
}
function AddLoginForm(props: IAddLoginFormProps)
{
    const { clientId, showTitle, variant = 'button' } = props;
    const [show, setShow] = useState(false);
    const [input, setInput] = useState('');
    const [passwordInput, setPasswordInput] = useState('');

    const { refreshTree, setNewAccount, setCurrentNode, setShowRightClickPopup } = context;
    const handleAdd = () => {
        addAccount();
        setShow(false);
    }
    const handleShow = () => {
        setInput('');
        setPasswordInput('');
        setShow(true);
    }
    const handleClose = () => {
        setShowRightClickPopup(false);
        setShow(false);
    }
    const successAdd = (newAccount: Account) => {
        handleClose();
        setNewAccount(newAccount);
        setCurrentNode(null);
        refreshTree();
        toast.success("Логин успешно добавлен.");
    }
    function addAccount() {
        if (input == '' || input == undefined)
            return;

        if (clientId == '' || clientId == undefined)
            return;

        const account: Account = {
            Login: input,
            ClientId: clientId,
            Password: passwordInput,
            Devices: { Devices_: [] },
            OriginalLogin: ""
        }
        centerClient.addAccount(account)
            .then((res) => {
                const data = res.data;
                if (data)
                    successAdd(data);
            })
            .catch(() => refreshTree());
        context.refreshTree();
    }
    return (
        <>
            {
                variant === 'dropdownItem' ?
                    <Dropdown.Item onClick={handleShow}>
                        <PersonPlusFill className='mediumSvg marginRight' />
                        Добавить логин
                    </Dropdown.Item>
                    :
                    <Button title="Добавить логин" variant="transparent" onClick={handleShow} ><PersonPlusFill fill="var(--account)" />{showTitle ? "Добавить логин" : ""}</Button>
            }
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Добавить логин</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Название</Form.Label>
                            <Form.Control type="input" value={input} onChange={e => setInput(e.target.value)} placeholder="Название" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Пароль</Form.Label>
                            <Form.Control type="input" value={passwordInput} onChange={e => setPasswordInput(e.target.value)} placeholder="Пароль" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="custom" onClick={handleAdd}>
                        Добавить
                    </Button>
                    <Button variant="custom" onClick={handleClose}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddLoginForm;